/**
 * Step type definitions
 * Three types of steps: Advanced, Default (no-code), and Function
 */

import { AdvancedStep, DefaultStep, FunctionStep, Step } from '@polyai/schemas';

export type {
  AdvancedStep,
  DefaultStep,
  FunctionStep,
  Step,
} from '@polyai/schemas';

type StepWithConditions = DefaultStep | FunctionStep;

export function isAdvancedStep(step: Step | undefined): step is AdvancedStep {
  return step?.type === 'advanced_step';
}

export function isDefaultStep(step: Step | undefined): step is DefaultStep {
  return step?.type === 'default_step';
}

export function isFunctionStep(step: Step | undefined): step is FunctionStep {
  return step?.type === 'function_step';
}

export function isStepWithConditions(
  step: Step | undefined,
): step is StepWithConditions {
  return isDefaultStep(step) || isFunctionStep(step);
}
